{
  "n/a": "N/A",
  "authorization_in_progress": "Authorizing ...",
  "will_redirect_to": "Will redirect you to",
  "login": {
    "identifying_organization": "Identifying your organization..."
  },
  "go_back": "Go back",
  "pairing": {
    "title": "Connect device",
    "instructions": "To connect your device, please start the client application on your device and enter the displayed pairing code.",
    "client_hint": "Before you can connect your device, please make sure you have downloaded and installed the client app.",
    "install_client": "Install client app",
    "failure": "Connection failed, the pairing code you entered ({{code}}) might be wrong or it could have been expired."
  },
  "clients": {
    "coming_soon": "Available upon Request",
    "go_to_overview": "Install another client app",
    "connected": "Connected",
    "connected_clients": "Paired Devices",
    "active": "Active",
    "set_active": "Select",
    "title": "Install client app",
    "instructions": "In order to enjoy the full experience, please download and install the client app to your device. The following platforms are currently supported:",
    "download_for_quest": "Meta",
    "download_for_focus": "VIVE",
    "download_for_pico": "PICO",
    "download_for_windows": "Windows",
    "connect_hint": "After installing the client app, please proceed with connecting your device.",
    "connect": "Connect device",
    "installation_title": "Install {{device}} client",
    "device": {
      "wave": "VIVE",
      "meta": "Meta Quest",
      "pico": "PICO",
      "desktop": "Windows",
      "apple_vision_pro": "Apple Vision Pro",
      "magic_leap": "Magic Leap"
    },
    "desktop_client": {
      "intro": "To support downloading and running applications locally, please first download the Windows client application's installer below:",
      "download_cta": "Download Installer",
      "installation_instructions": "After downloading the installer, please follow the installation instructions to install the client application on your Windows computer."
    },
    "installation_methods": {
      "intro": "To install the client application for {{device}}, please pick one of the following methods:",
      "sideloading": {
        "title": "Sideloading",
        "requirements": "Installing the client via sideloading requires your {{device}} to have developer mode enabled.",
        "download_first": "To install the client application via sideloading, please first download the application's <1>apk</1> below:",
        "download": "Download apk",
        "method_intro": "After having downloaded the apk to your computer, please follow the guide to install the application on your {{device}} via sideloading:",
        "recommended": "recommended",
        "official_guide": "official guide"
      },
      "meta_applab": {
        "title": "Meta Store",
        "text": "To install the client application for your Quest device via Meta Store, simply click the following button and follow the instructions there:",
        "cta": "Go to Meta Store"
      },
      "vive_business_appstore": {
        "title": "VIVE Business AppStore",
        "text": "To install the client application for your VIVE device via the VIVE Business App Store, simply click the following button and follow the instructions there:",
        "cta": "Go to VIVE Business AppStore"
      },
      "pico_enterprise_store": {
        "title": "Pico Enterprise Store",
        "text": "To install the client application for your PICO Enterprise device, please open the store on your PICO Enterprise device and search for 'Innoactive Portal'."
      },
      "recommended": "Recommended",
      "mdm": {
        "title": "Mobile Device Management (MDM)",
        "intro": "To distribute the {{device}} client application via a Mobile Device Management (MDM) system, please follow the guide below.",
        "copy_download_url": "Click to copy client application apk URL",
        "steps": {
          "login": {
            "title": "Log In to the MDM Admin Console",
            "text": "Access your MDM platform’s administrative console using your credentials. This can typically be done through a web browser."
          },
          "navigate_to_app_management": {
            "title": "Navigate to App Management",
            "text": "Go to the section within the MDM console where you can manage applications, often labeled as ‘Apps’, ‘Applications’, or ‘App Catalog’."
          },
          "add_application": {
            "title": "Add the Application",
            "text": "Look for an option to ‘Add’, ‘Upload’, or ‘Deploy’ a new application. This might include options to either upload an APK directly or link to an external APK. You can use the following URL to either download the APK and upload it to the MDM system or use it to externally link the APK:"
          },
          "choose_deployment_method": {
            "title": "Choose Deployment Method",
            "text": "Depending on your MDM platform, you may have different options to add the application.",
            "options": {
              "direct_upload": {
                "title": "Direct Upload",
                "text": "Select ‘Upload’ and choose the APK file from your computer to upload it directly to the MDM system."
              },
              "external_link": {
                "title": "External Link",
                "text": "Select ‘Add by URL’ or ‘Link External Application’ and provide the URL where the APK is hosted."
              }
            }
          },
          "configure_app_settings": {
            "title": "Configure App Settings",
            "text": "Enter necessary details about the application such as name, description, version, and any other metadata required by your MDM platform.",
            "text2": "Define deployment settings such as which users or groups the app should be available to, and any conditional access based on device compliance."
          },
          "set_permissions_and_policies": {
            "title": "Set Permissions and Policies",
            "text": "Configure app-specific permissions required for functionality.",
            "text2": "Establish security policies and data handling rules that align with organizational standards."
          },
          "deploy_the_application": {
            "title": "Deploy the Application",
            "text": "Assign the app to specific groups or users. Depending on your choice, click ‘Publish’, ‘Deploy’, or a similar option to make the application available through the MDM."
          },
          "verify_deployment": {
            "title": "Verify Deployment",
            "text": "Monitor the deployment status through the MDM console to ensure the application is successfully distributed and installed on the targeted devices.",
            "text2": "Check for installation errors and address any user-reported issues."
          },
          "manage_updates_and_support": {
            "title": "Manage Updates and Support",
            "text": "Regularly check for new versions of the application and repeat the upload or update the external link as necessary.",
            "text2": "Provide ongoing support for end-users and maintain clear communication about application updates and new features."
          }
        }
      }
    },
    "download_for_apple_vision_pro": "Apple Vision Pro",
    "download_for_magic_leap": "Magic Leap 2"
  },
  "footer": {
    "terms": "Usage Terms",
    "privacy": "Data Privacy",
    "legal": "Legal",
    "version": "Version (Web): {{version}}",
    "powered_by": "This service is brought to you by Innoactive. <2>innoactive.io/portal</2>",
    "support": "Support"
  },
  "header": {
    "search": "Search",
    "language": "Language",
    "logout": "Logout",
    "security": "Security",
    "streaming": "Streaming"
  },
  "search": {
    "no_app": "It looks like there are no matching applications for your search term \"{{term}}\".",
    "placeholder": "Search for apps",
    "minimum_chars": "Please enter a minimum of three characters to start searching",
    "filter": {
      "label": "Filter",
      "rendering": {
        "title": "Rendering",
        "label": "Render Type: {{type}}",
        "all": "Any render mode",
        "local": "Local only",
        "streaming": "Streaming only"
      },
      "device": {
        "title": "Device",
        "label": "Device Type: {{type}}",
        "all": "All Devices",
        "win-non-vr": "Browser",
        "win-vr": "Windows VR",
        "quest": "Meta Quest",
        "wave": "HTC Vive",
        "pico": "PICO",
        "magic-leap": "Magic Leap"
      }
    }
  },
  "languages": {
    "en": "English",
    "de": "German",
    "es": "Spanish"
  },
  "details": {
    "unsupported": "Unsupported",
    "launch_in_cloud": "Stream to XR headset",
    "launch_browser": "Stream to Browser",
    "launch_on_standalone_device": "Run on XR headset",
    "launch_locally": "Download and run locally",
    "edit": "Edit in Control Panel",
    "available_clients": "Available {{clients}}",
    "vr_clients": "VR devices",
    "generic_clients": "devices",
    "pair_vr_device": "Connect device",
    "stream_to_device": "Stream to {{name}}",
    "launch_on_device": "Run on {{name}}",
    "not_installed_on_device": "Not installed on {{name}}",
    "install_on_device": "Install and run on {{name}}",
    "install_on_server": "Install on streaming server",
    "queue_for_installation": "Queue for installation",
    "fast_launch_tooltip": "Fast launch - App is pre-installed on server",
    "installing": "Requesting installation",
    "installed_addendum": " (Installed)",
    "related_apps": "Related Apps",
    "not_connected_title": "Disconnected!",
    "not_connected_text": "There's currently no connection to the background service. Please restore the connection or contact an administrator.",
    "streaming_preferences": "Streaming preferences",
    "download_apk": "Download .apk",
    "download_exe": "Download .zip",
    "download_windows_vr": "Download Windows VR build (.zip)",
    "download_windows_non_vr": "Download Windows Non-VR build (.zip)",
    "no_actions_available_title": "No actions available",
    "no_actions_available": "There are no actions available for this application. Please connect a suitable device to run the application on and verify the application's configuration.",
    "changelog": "Changelog",
    "no_changelog_available": "No changelog provided",
    "not_installed_addendum": " (Not installed)",
    "connecting_title": "Connecting ...",
    "connecting_text": "Trying to (re-)establish a connection to the service...",
    "changelog_show_more": "Show more...",
    "stream_preferences_wizard": "Server Location Wizard",
    "switch_version": "Switch version",
    "device_incompatible_tooltip": "The selected device does not support encrypted streaming.",
    "disconnected_tooltip": "No connection to the service.",
    "download_windows": "Download build for <2>{{platforms}}</2>",
    "standalone_app_not_installed": "Application not installed on your device. Please install the application in order to run it.",
    "standalone_app_not_installed_title": "Application not installed"
  },
  "request_access": {
    "request_access": "Request Access",
    "access_requested": "Access requested ({{relativeDate}}).",
    "message_label": "Please provide some information on why you require access ...",
    "cancel": "Cancel",
    "submit": "Submit",
    "pending_request": "You already requested access. Your message was: ",
    "handled_externally": "Please go to <2>{{url}}</2> to request access to this application."
  },
  "launch": {
    "launch_app": "Launching application",
    "launch_app_with_name": "Launch <strong>\"{{name}}\"</strong>",
    "custom_protocol_prompt_instruction": "Click  <strong>\"Open Portal Desktop Client\"</strong> on the dialog shown by your browser.",
    "custom_protocol_prompt_reopen": "If you don't see a dialog, make sure you have Portal Desktop Client installed\nand click <strong>\"{{action}}\"</strong> below.",
    "custom_protocol_prompt_reopen_action": "Launch {{name}}",
    "desktop_client_not_installed_question": "Don't have Portal Desktop Client installed?",
    "download_now": "Download now",
    "check_desktop_client_installation": "Waiting for Desktop Client",
    "app_not_found_invalid_id": "Invalid application ID.",
    "app_not_found_title": "Unable to load application information.",
    "app_not_found": "This could be due to insufficient permissions or the application may not exist. Please verify your access rights or contact support for assistance.",
    "region_incompatible": "Region incompatible",
    "region_incompatible_detail": "Our systems have detected that your desired region ({{ preferredRegion }}) either does not support streaming for the selected application or we cannot ensure that the region is reachable from your device. We recommend to continue using region {{ bestRegion }} instead.",
    "region_incompatible_force_continue": "If you know what you are doing you can also click the following link to <2>ignore this warning and continue using \"{{ preferredRegion }}\"</2> at the risk of a degraded experience.",
    "force_continue": "Keep {{ regionName }}",
    "region_no_capacity": "Region out of capacity",
    "region_no_capacity_detail": "Your desired region {{ preferredRegion }} cannot be used at the moment due to a lack of rendering resources.",
    "region_no_capacity_loading": "Please be patient while we're looking for alternative regions to render in...",
    "no_region_available": "No streaming server available",
    "no_region_available_detail": "There is no compatible streaming server for the selected application. Please contact your organization administrator.",
    "back": "Back",
    "cancel": "Cancel",
    "continue": "Use {{ regionName }}",
    "launch_type_unsupported": "Unsupported session type!",
    "region_no_capacity_redirect_detail": "Your desired region {{ preferredRegion }} cannot be used at the moment due to a lack of rendering resources. We have automatically redirected your session to run in {{ alternativeRegion }} instead.",
    "region_no_capacity_alternative": "You can either try again at a later time or continue using region {{ alternativeRegion }} instead?",
    "unknown_region": "Unknown region",
    "select_target_device": "Please select which of your connected devices should be used to run the session:",
    "select_vm_size": "Please select the performance tier you want to use to run your application in {{ regionName }}:",
    "force_continue_with_vm_size": "Use {{ regionName }} ({{ vmSize }})",
    "region_requires_vm_size_change": "Region requires additional configuration",
    "back_to_recommendation": "Back to recommendation",
    "vm_size_too_small": "The selected performance tier ({{ selectedVmSize }}) is lower than the requirement for the application ({{ targetVmSize }}). Please be aware that ignoring this fact can lead to degraded performance.",
    "no_app_build_for_launch": "No compatible application build found for requested launch.",
    "application_not_installed_on_device": "Application not installed on device. Please install it first!",
    "no_matching_launch_configuration": "Couldn't identify how to launch the selected application",
    "select_launch_configuration": "Please select how you want the application to be started",
    "potentially_uninstalled_desktop_client": "It looks like you might not have Portal Desktop Client installed yet, please make sure it is installed on your Windows PC first.",
    "potentially_uninstalled_desktop_client_title": "Portal Desktop Client not installed?",
    "go_to_desktop_client_installation_instructions": "Show installation instructions",
    "potentially_uninstalled_desktop_client_dialog_close": "Close",
    "desktop_client_unsupported_platform": "Launching this application locally is not supported on your device. Please switch to a Windows PC to launch this application locally or use another way of launching the application.",
    "show_alternative_launch_modes": "Launch app differently",
    "device_incompatible": "Device incompatible",
    "device_not_supporting_encrypted_vr_streaming_error": "The device you selected cannot be used for encrypted VR streaming. Please ensure that you have granted the necessary permission on the device to enable encrypted streaming to the XR headset.",
    "error_fetching_encryption_setting": "Failed loading user preferences / organization policies",
    "legacy": {
      "unsupported_launch_mode": "Unsupported launch mode!"
    },
    "latency_test_required_info": "Identifying best server location ...",
    "selected_region_incompatible_no_alternative": "Our systems have detected that your desired region ({{ preferredRegion }}) either does not support streaming for the selected application or we cannot ensure that the region is reachable from your device. There is no alternative streaming server available to you at this time. Please reach out to an administrator."
  },
  "notifications": {
    "title": "Session Notification",
    "MaxSoftSessionRunTime": "Your session has been running for quite some time. Please end it if you do not need it anymore.",
    "MaxSessionRunTime": "Your session has exceeded the maximum runtime and will be terminated automatically.",
    "HighLatency": "High latency warning for current session in {{ region }} {{ latency }}ms. The performance might be affected by this.",
    "SessionInactivityTimeoutTime": "Session terminated because device was idle for too long.",
    "HotVirtualMachineWithPreInstalledAppsUsed": "This Session uses a hot Reserved Instance with pre-installed apps.",
    "VirtualMachineDestroyedBecauseOfError": {
      "generic": "The virtual machine could not be provisioned due to a technical error. Please try again.",
      "CloudProviderNoAvailability": "No virtual machines are available in the selected cloud region. Please try a different region or try again later.",
      "ImageNotFound": "The required virtual machine image was not found. Please contact support.",
      "CouldNotProvision": "An infrastructure configuration error occurred. Please contact support.",
      "title": "Infrastructure Error"
    }
  },
  "streaming_server_not_ready": {
    "title": "Streaming server is being prepared",
    "description": "Your personal streaming server is still installing applications. This may take a few minutes.",
    "wait_option": "Go back and wait",
    "new_server_option": "Get a new streaming server",
    "new_server_warning": "Getting a new server will destroy your pending server to avoid additional costs."
  },
  "app": {
    "streaming_server_preparing": "Preparing server",
    "streaming_server_details": "Streaming Server Details",
    "streaming_server_status": "Status",
    "preparing": "Preparing",
    "streaming_server_region": "Region",
    "streaming_server_size": "Size",
    "streaming_server_apps": "Installed Apps",
    "streaming_server_created": "Created",
    "streaming_server_preparing_message": "Your streaming server is being prepared. This usually takes a few minutes.",
    "schedule_session": "Schedule Session"
  },
  "session": {
    "pairing": {
      "no_device_pico": "Please pair your PICO device to proceed launching the application.",
      "no_device_quest": "Please pair your Quest device to proceed launching the application.",
      "no_device_wave": "Please pair your Vive device to proceed launching the application.",
      "connect_standalone_device": "Please connect any standalone XR headset to proceed launching the application."
    },
    "end": "End Session",
    "abort": "Cancel",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "idle": "No active session",
    "browse": "Browse through the available apps",
    "ready": "Session is ready!",
    "ready_short": "Session ready!",
    "notification": "Please click here to go to your session now!",
    "ready_instructions": "Please continue with \"{{ device }}\".",
    "ready_instructions_xr": "Please put on your \"{{ device }}\" to continue.",
    "ready_instructions_desktop": "Please continue on your desktop.",
    "seconds": "sec",
    "seconds_plural": "secs",
    "minutes": "min",
    "minutes_plural": "mins",
    "running": "Session is running!",
    "app_running": "\"{{name}}\" is running on {{ device }}.",
    "app_running_browser": "\"{{name}}\" is running. You will be connected shortly...",
    "running_on": "Running on: <strong>{{name}}</strong>",
    "networking_problems_title": "Network performance issues detected",
    "networking_problems": "We’ve noticed network performance issues on your XR headset.",
    "networking_latency": "• Your network latency is too high",
    "networking_bandwidth": "• Your bandwidth is not high enough",
    "networking_unstable": "• Your connection seems to be too unstable",
    "networking_help": "For more information, please visit our",
    "abort_dialog": {
      "title": "Abort Session",
      "are_you_sure": "Are you sure you want to end this session?"
    },
    "session_already_running_dialog": {
      "title": "Existing session detected",
      "body": "By confirming below, your existing session will be terminated and a new session will be started to run the selected application.\n\nClick cancel to go to the active session instead."
    },
    "application_requires_update_dialog": {
      "title": "New Version ready",
      "body": "There is a new version for application ready to be installed, do you want to install it?"
    },
    "session_error_dialog": {
      "title": "There seems to be a problem with your session",
      "continue": "Dismiss",
      "additional_info": "Please use the session ID below to get further assistance from support:",
      "report": "Support",
      "report_summary_session": "Issue in session {{ sessionId }}",
      "report_summary_starting_session": "Issue while starting a session",
      "report_description": "{{ errorMessage }}.\n\nPlease provide additional information about what happened before the error occurred.",
      "title_startup": "We encountered an issue while trying to start the session"
    },
    "unexpected_error": "An unexpected error occurred",
    "go_to_session": "Go to session",
    "ready_acknowledge": "Go to session",
    "active": "Active session",
    "ready_in": "Ready in",
    "ending": "Ending ...",
    "notification_enabled_title": "Notifications enabled",
    "notification_enabled_text": "We will notify you when your session is ready even if you're not on this page.",
    "notification_denied_title": "Enabling Notifications failed",
    "notification_denied_text": "It seems like your browser prohibits any notifications from this page. Please check your browser's settings!",
    "skip": "Skip",
    "update": "Install",
    "debug": {
      "id": "Session ID",
      "server_ip": "IP address",
      "latency": "Latency",
      "enable_debug": "Enable debug mode",
      "enable_debug_tooltip": "Open VNC and RDP ports on VM",
      "debug_enable_tooltip": "Debug mode already enabled",
      "duration": "Duration",
      "app_version_api_id": "Version ID",
      "app_api_id": "App ID",
      "vm_image": "VM Image",
      "header": "Session information",
      "streaming_server": "Streaming Server",
      "xr_encryption_enabled": "End-to-end encrypted",
      "streaming_protocols": "Streaming protocols",
      "xr_device": "Device",
      "xr_gateway_used": "via XR gateway"
    },
    "preparing": "Preparing your session!",
    "notified_when_ready": "We'll notify you once preparations are done.",
    "enable_notifications_to_be_notified": "To get notified once ready, please click <2>here</2>",
    "taking_longer_than_expected": "Will be streaming soon.",
    "calculating_wait_time": "Estimating wait time...",
    "rate_dialog": {
      "title": "How good was the quality of your experience?",
      "cancel": "Dismiss",
      "rate_action": "Submit",
      "placeholder": "More information"
    },
    "switch_organization": "Switch to {{organizationName}}",
    "switch_organization_info": "To view this session, please switch to {{organizationName}} organization or end the session to start a new one.",
    "application": "Application"
  },
  "spectator": {
    "actions": {
      "copy": "Copy text",
      "paste": "Paste text"
    },
    "connection": {
      "new": "Please grant access to your microphone",
      "establishing": "Establishing connection",
      "connecting": "Connecting",
      "connected": "Connected. Waiting for stream to start",
      "disconnected": "Disconnected",
      "closed": "Connection closed",
      "no_frames": "Waiting for stream to start...",
      "no_frames_hint": "We haven’t received any video (yet). This could just be a short delay — or the app might not be showing anything we can stream. If nothing shows up after a bit, try restarting the app or checking your connection."
    },
    "microphone": {
      "failed": "Failed enabling microphone",
      "unmuting-failed": "Could not unmute microphone. Possibly, access to microphone was declined within this browser."
    },
    "clipboard": {
      "error": {
        "missing-permission-title": "Clipboard access denied",
        "missing-permission-description": "Please check your browser settings and allow access to the clipboard."
      }
    },
    "fullscreen": {
      "turn-to-enable-title": "Turn your device",
      "turn-to-enable-description": "To enable fullscreen mode, please change your device's orientation to landscape mode.",
      "turn-to-disable-title": "Turn your device",
      "turn-to-disable-description": "To disable fullscreen mode, please change your device's orientation to portrait mode."
    },
    "audio": {
      "blocked_by_browser_policy": "Your browser's policy currently prevents playing back audio until you manually unmute by clicking below.",
      "unmute": "Unmute",
      "ignore": "Ignore"
    },
    "remoteUrls": {
      "text": "The application tried to open the following URL remotely. Click below to open it in your browser instead:",
      "title": "Remote URLs"
    },
    "windows": {
      "switch": "Switch window"
    }
  },
  "legal": {
    "title": "Legal information",
    "managing_director": "Managing director",
    "contact": "Contact",
    "other": "Other legal information",
    "vat": "VAT-ID"
  },
  "privacy": {
    "title": "Data Privacy"
  },
  "terms": {
    "title": "Terms and conditions"
  },
  "list": {
    "empty": {
      "title": "Aw Snap!",
      "description": "It looks like there are no applications available to you (yet)!",
      "action_description": "There are no applications yet. Start by uploading your first one in the Control Panel.",
      "action_description_no_permission": "No applications available. Please ask your administrator to assign permissions so you can access applications.",
      "action_label": "Manage applications"
    },
    "view": {
      "categories": "Categories",
      "all": "All apps"
    },
    "no_results": "No applications match the selected filters."
  },
  "device": {
    "came_online_title": "Device online",
    "came_online": "Your device {{name}} just came online",
    "went_offline_title": "Device offline",
    "went_offline": "Your device {{name}} just went offline"
  },
  "menu": {
    "control_panel": "Control Panel",
    "admin_panel": "Admin Panel"
  },
  "preferences": {
    "dialog": {
      "title": "Preferences",
      "explanation": "You can adapt your preferences for cloud rendering to optimize performance for your specific use case and current location. We strongly recommend to not change these settings unless absolutely required. Please use the Server Location Wizard to determine your best server location.",
      "preferredCloudProvider": "Active cloud providers",
      "savedTitle": "Changes saved",
      "saved": "Successfully updated your cloud rendering preferences.",
      "savedSecurity": "Successfully updated your security preferences.",
      "errorTitle": "Error",
      "error": "Changes could not be saved.",
      "regions": "Available regions",
      "automaticModeLabel": "Enable automatic mode",
      "manualModeLabel": "Enable manual mode",
      "vm_sizes": "Sizes",
      "savedStreamingProtocol": "Successfully updated your streaming preferences."
    },
    "map": {
      "setaspreferred": "Select",
      "ispreferred": "Selected",
      "distance": "Distance (approx.)",
      "latency": "Latency",
      "region": "Region",
      "disabled": "Not usable"
    },
    "preferred_region_unavailable": "Region unavailable",
    "preferred_region_unavailable_details": "Your desired region \"{{ preferredRegion }}\" is not available at present or cannot be used for streaming. Please choose another region to use streaming or switch on automatic mode.",
    "preferred_region_unsupported": "Region unsupported",
    "preferred_region_unsupported_details": "Our systems have detected that your desired region \"{{ preferredRegion }}\" does not support streaming of the selected application. We recommend to choose another region to use streaming or switch on automatic mode. If you know what you are doing you can also choose to ignore this warning and continue using \"{{ preferredRegion }}\" at the risk of a degraded experience",
    "security_preferences": "Security",
    "region_preference": "Server location",
    "security": {
      "encrypt_vr_stream": "Encrypt VR Streams",
      "encrypt_vr_stream_help_text_disabled": "Using VR streaming without encryption can yield lower latency and better user experience at the expense of reduced security.",
      "encrypt_vr_stream_help_text_enabled": "Encryption for VR streaming increases security and is highly recommended.",
      "debug_mode": "Enable VM Debug Mode",
      "debug_mode_help_text_disabled": "Debug mode is disabled on VM by default",
      "debug_mode_help_text_enabled": "Debug mode is enabled by default on the VM",
      "policies_deny_encrypt_vr_stream_change": "Your organization's policies prevent you from changing this setting. Please contact your administrator."
    },
    "streaming": {
      "custom_vm_image": "(Custom) VM Image",
      "custom_vm_image_help_text": "Specifying a custom virtual machine (VM) image above allows to run on an application on a machine with different presets or features. Possible values for this setting depend on the deployment. Note that not all VM images are available in all streaming regions.",
      "vm_id": "Virtual Machine ID",
      "vm_id_help_text": "Specifying a VM ID to ensure consecutive sessions are run on the same VM"
    },
    "protocols": {
      "use_xr_gateway": "Use gateway for XR Streaming",
      "use_xr_gateway_help_text_disabled": "In selected locations you can use a centralized gateway to connect to XR streams. This adds minimal overhead (latency).",
      "use_xr_gateway_help_encryption_required": "To use a gateway for XR streaming, encryption must be enabled."
    },
    "advanced": "Advanced"
  },
  "invitation": {
    "accepted": {
      "title": "Welcome to {{name}}!",
      "description": "You have successfully accepted the invitation and can now start browsing the available content."
    }
  },
  "vmUpgradeNotification": {
    "title": "Performance tier upgraded",
    "description": "Your session was launched on a higher-performance streaming server to reduce startup time."
  },
  "or": "or",
  "featureFlags": {
    "title": "Feature Flags",
    "description": "Feature flags allow enabling / disabling certain (experimental!) features. Features enabled here only apply for your user account and only within the currently active organization."
  },
  "server_location_wizard": {
    "region": "Region",
    "cloud_provider": "Cloud Provider",
    "distance": "Distance (approx.)",
    "latency": "Latency",
    "hide_details": "Hide details",
    "show_details": "Show details",
    "restart_test": "Restart checks",
    "title": "Server Location Wizard",
    "test_description": "To optimize the streaming experience, we are checking the render locations to find the best one for you.",
    "network": "Network",
    "your_pc": "Your PC",
    "cloud_rendering_infrastructure": "Streaming Server",
    "success_header": "Best server location identified!",
    "keep_page_open_warning": "For best results, stop any potentially running downloads, keep this page open, and do not switch to another tab while the automated checks are running.",
    "close": "Close Wizard",
    "latency_table_description": "Below you see a list of all available render locations from which you can stream an application. You can manually (re-)evaluate certain locations in order to determine their performance for streaming or manually select one to override the automatic selection.",
    "latency_table_select_all": "Select all (on this page)",
    "check_selected_regions": "Check selected locations",
    "check_selected_regions_button_disabled_hint": "Please select some locations to check first",
    "cancel": "Cancel",
    "proceed": "Proceed",
    "heading": "Server Location Finder",
    "prevent_navigation_title": "Abort?",
    "abort_dialog_body": "Latency checks are still running - are you sure you want to leave?",
    "prevent_navigation_abort": "Abort & Leave",
    "prevent_navigation_stay": "Continue",
    "latency_test_running": "For best results, please keep this page focussed while checks are in progress."
  },
  "createRenderMachine": {
    "toast": {
      "title": "Streaming Server requested",
      "description": "The Streaming Server has been requested. It might take some time until the Machine is ready to be used"
    },
    "toast_error": {
      "title": "Could not create the Streaming Server",
      "description": "The Streaming Server could not be created. Please try again later"
    }
  },
  "destroyRenderMachine": {
    "toast": {
      "title": "Machine destroy successfully requested",
      "description": "The machine will be destroyed"
    },
    "toast_error": {
      "title": "An error occurred during the destruction of the machine",
      "description": "The machine destroy could not be requested. Please try again later."
    }
  },
  "streaming_server": {
    "terminate_dialog": {
      "title": "Terminate Streaming Server",
      "are_you_sure": "Are you sure you want to terminate and remove this streaming server?",
      "cancel": "Cancel",
      "confirm": "Confirm"
    },
    "stream_button": {
      "destroy": "Terminate",
      "cancel": "Cancel streaming server",
      "create_button": "Create Streaming Server",
      "expires_in_time": "Expires in {{time}} h",
      "expired": "Expired"
    },
    "status": {
      "provisioning_infrastructure": "Provisioning streaming server",
      "infrastructure_ready": "Streaming server resources ready",
      "booting_server": "Starting streaming server",
      "configuring_network": "Configuring server network",
      "installing_apps": "Installing applications",
      "finalizing_setup": "Finalizing server setup",
      "ready": "Ready",
      "preparing": "Preparing streaming server",
      "errored": "Streaming server failed",
      "creating": "Starting",
      "booting": "Starting",
      "installing": "Installing",
      "default": "Streaming"
    },
    "status_short": {
      "provisioning_infrastructure": "Provisioning",
      "infrastructure_ready": "Preparing",
      "booting_server": "Starting",
      "configuring_network": "Configuring",
      "installing_apps": "Installing",
      "finalizing_setup": "Finalizing",
      "ready": "Ready",
      "preparing": "Preparing",
      "errored": "Failed"
    },
    "intent_status": {
      "selecting_region": "Selecting best region…"
    },
    "error_dialog": {
      "title": "Streaming Server Error",
      "RetriesExhausted": "We couldn't set up your streaming server. All available regions were tried but none could provision a server successfully.",
      "NoRegionFound": "No suitable region could be found to provision a streaming server.",
      "suggestion": "This is usually a temporary issue. Please try again in a few minutes, or select a different region manually in your preferences.",
      "additional_info": "For support, please provide the following intent ID:",
      "report": "Contact Support",
      "dismiss": "Dismiss",
      "report_summary": "Streaming server error for intent {{ intentId }}",
      "report_description": "The streaming server failed to provision.\\nRegion: {{ region }}\\nSize: {{ size }}",
      "copy": "Copy",
      "copied": "Copied"
    },
    "extend": {
      "add_1_hour": "Extend by 1 hour",
      "add_2_hours": "Extend by 2 hours",
      "add_3_hours": "Extend by 3 hours",
      "success": "Extension successful",
      "success_description": "Server extended by {{hours}} hour(s)",
      "error": "Extension failed",
      "error_description": "Could not extend the server expiration time"
    },
    "ready_notification": {
      "title": "Streaming Server Ready",
      "message": "Your streaming server is now ready. The application will start streaming automatically.",
      "auto_proceed": "Starting in {{seconds}} seconds...",
      "cancel": "Cancel",
      "proceed": "Start Streaming"
    },
    "region": {
      "select": "Select Region",
      "manual": "(Manual)",
      "automatic": "Automatic Selection",
      "automatic_description": "Automatically select the best region based on latency",
      "search": "Search",
      "search_placeholder": "Search regions...",
      "filters": "Filters",
      "clear_filters": "Clear",
      "no_regions_found": "No regions found",
      "cloud_providers": "Cloud Providers"
    },
    "dialog": {
      "title": "Create Streaming Server",
      "sub_heading": "Select the applications you want to pre-install on your streaming server. Pre-installation reduces session loading times.",
      "selected_apps": "Selected applications",
      "available_apps": "Available applications",
      "no_apps_selected": "No apps selected yet. Choose one or more apps below.",
      "search_placeholder": "Search for apps",
      "server_configuration_section": "Server configuration",
      "server_recommendation": "Based on your selection, we recommend the following setup:",
      "change": "Change",
      "cancel": "Cancel",
      "selectNumberOfApps": "Select applications that should be pre-installed. Pre-installing apps decreases the session loading time. Based on the selected applications and your connection quality we determined that ",
      "bestRegion": " is the best region with performance tier ",
      "youCan": "You can",
      "overwriteRegion": "change the location selection manually",
      "additionallyYouCan": "Additionally you can",
      "overwriteMachineSize": "manually change the machine performance",
      "hideAndResetManualRegionSelection": "Reset and hide location selection.",
      "hideAndResetManualVmSizeSelection": "Reset and hide performance tier selection.",
      "createRenderMachine": "Create Streaming Server",
      "clearAllPreInstalledApps": "Clear selection",
      "cannot_select_tooltip": "Max Pre-Installed apps reached",
      "noValidRegionAvailable": "We could not find a region to create your streaming server in with the desired settings and / or applications. Please change your settings or reach out to an administrator.",
      "overrideRegion": "Override region",
      "overrideVmSize": "Override performance tier",
      "resetRegionToDefault": "Reset to recommended region",
      "resetVmSizeToDefault": "Reset to recommended performance tier"
    },
    "status_button": {
      "disable_button": "Click to stop using this server",
      "enable_button": "Click to use this server",
      "destroy_tooltip": "Destroy this server?",
      "active": "Active",
      "select": "Select"
    },
    "conflict": {
      "title": "Streaming Server Compatibility Issue",
      "xr_gateway_not_supported": "Your existing streaming server in {{region}} does not support XR Gateway, which is currently required by your preferences or organization policy.",
      "explanation": "To proceed with launching the application, you can choose one of the following options:",
      "option_1_title": "Create New Streaming Server",
      "option_1_description": "Create a new server with the required specifications.",
      "option_2_title": "Change Preferences",
      "option_2_description_xr": "Disable XR Gateway requirement.",
      "change_preferences_button": "Change Preferences",
      "create_new_button": "Create New Server",
      "vm_size_too_small": "Your existing streaming server in region {{region}} ({{currentSize}}) does not meet the minimum size requirement ({{requiredSize}}) for this application.",
      "vm_size_explanation": "Your existing streaming server's performance is insufficient for the requested application. You must create a new streaming server with sufficient resources to proceed.",
      "option_1_additional_info": "Streaming server will be created in {{region}}.",
      "create_new_in_other_region_button": "Create New Server ({{region}})",
      "disable_xr_gateway_button": "Disable XR Gateway"
    }
  },
  "authorization_error": "An unexpected error occurred",
  "streamer": {
    "dcv": {
      "preferences": {
        "mode_responsiveness": "Best responsiveness",
        "mode_quality": "Best quality",
        "mode_responsiveness_help": "Provides most fluid experience.",
        "mode_quality_help": "Provides best image quality.",
        "high_color_accuracy": "High Color Accuracy (YUV 4.4.4)",
        "high_color_accuracy_help": "Streaming performance could be affected.",
        "streaming_mode": "Streaming mode",
        "high_color_accuracy_enabled": "Enabled",
        "high_color_accuracy_disabled": "Disabled",
        "title": "DCV Preferences",
        "change": "Manage DCV preferences"
      },
      "high_color_accuracy_unsupported": "High color accuracy is not supported",
      "resolution_capped_title": "Limited remote resolution",
      "resolution_capped_description": "This machine can't match its resolution to your window, so you may see black bars around the stream. Reconnecting may assign a machine that fits.",
      "stats": {
        "show": "Show streaming stats",
        "hide": "Hide streaming stats",
        "fps": "FPS",
        "latency": "Latency",
        "traffic": "Traffic",
        "peak": "peak"
      }
    }
  },
  "user": {
    "preferences": "Preferences",
    "scheduled_sessions": "Scheduled Sessions",
    "expert_mode": "Expert mode",
    "expert_mode_description": "Enable to unlock additional features. Only recommended for expert users.",
    "notifications_badge": "{{count}} items need attention"
  },
  "installable_app": {
    "queued": "Installation of {{appName}} is queued",
    "installing": "{{appName}} is being installed ..."
  },
  "latency_checks": {
    "running_button": "Identifying best server"
  },
  "organization": {
    "error_loading": "Error fetching organization information"
  },
  "branding": {
    "loading": "Loading branding for organization ...",
    "error_loading": "Failed to load branding"
  },
  "generic": {
    "not_available_short": "N/A"
  },
  "schedule": {
    "modal": {
      "title": "Schedule Session",
      "edit_title": "Edit Session",
      "application": "Application",
      "name": "Event Name",
      "name_placeholder": "Enter a name for this session",
      "start_time": "Start Time",
      "end_time": "End Time",
      "end_time_error": "End time must be after start time",
      "max_duration_error": "Event duration cannot exceed {{maxHours}} hours",
      "participants": "Participants",
      "select_user": "Select a user to add",
      "search_user": "Search for a user...",
      "no_users_found": "No users found",
      "add_participant": "Add participant",
      "remove_participant": "Remove participant",
      "no_participants": "No participants added yet",
      "requires_cloud": "Cloud infrastructure",
      "cancel": "Cancel",
      "schedule": "Schedule",
      "update": "Update Session",
      "done": "Done",
      "success_title": "Session Scheduled!",
      "success_description": "Your session has been created. Share the link below with participants so they can confirm their attendance.",
      "rsvp_link": "RSVP Link",
      "copy_link": "Copy link",
      "rsvp_link_description": "Share this link with participants to confirm their attendance",
      "no_stream_access": "User does not have stream access. Click to manage permissions."
    },
    "list": {
      "title": "Scheduled Sessions",
      "empty": "No scheduled sessions yet",
      "column_name": "Name",
      "column_time": "Time",
      "column_participants": "Participants",
      "column_apps": "Applications",
      "apps": "apps",
      "past": "Past",
      "ongoing": "Ongoing",
      "edit": "Edit",
      "delete": "Delete",
      "rsvp": "RSVP",
      "open_rsvp": "Open RSVP Page",
      "add_to_calendar": "Add to calendar",
      "copy_id": "Copy ID",
      "copy_id_success": "ID copied to clipboard",
      "delete_title": "Delete Scheduled Session",
      "delete_confirm": "Are you sure you want to delete \"{{name}}\"?",
      "cancel": "Cancel",
      "filter": {
        "title": "Time",
        "show_past": "Show past Scheduled Sessions"
      },
      "infrastructure": {
        "title": "Infrastructure Status",
        "ready": "Ready",
        "provisioning": "Provisioning...",
        "pending": "Pending",
        "not_accepted": "Not accepted",
        "not_required": "Not required",
        "error": "Error",
        "no_permission": "No permission",
        "no_permission_hint": "You don't have permission to view other participants' infrastructure status."
      },
      "rsvp_status": {
        "title": "RSVP Status",
        "accepted": "Accepted",
        "declined": "Declined",
        "pending": "Pending"
      }
    },
    "toast": {
      "created": {
        "title": "Session Scheduled",
        "description": "Your session has been scheduled successfully"
      },
      "updated": {
        "title": "Session Updated",
        "description": "Your session has been updated successfully"
      },
      "deleted": {
        "title": "Session Deleted",
        "description": "Your scheduled session has been deleted"
      },
      "error": {
        "title": "Error",
        "description": "An error occurred. Please try again."
      }
    },
    "rsvp": {
      "invitation": "You have been invited to this session",
      "add_to_calendar": "Add to calendar",
      "participants": "participants",
      "you": "You",
      "accept": "Accept",
      "decline": "Decline",
      "event_past": "This event has already ended",
      "event_deleted": "This event has been deleted",
      "already_accepted": "You have already accepted this invitation",
      "already_declined": "You have declined this invitation",
      "latency_required": "Location check required",
      "latency_description": "To ensure the best experience, we need to check your connection to our servers.",
      "run_latency_test": "Run connection test",
      "latency_running": "Checking connection quality...",
      "error": {
        "title": "Error",
        "not_found": "The event could not be found",
        "not_participant": "You are not a participant of this event"
      },
      "toast": {
        "success": {
          "title": "Response Recorded",
          "description": "Your RSVP has been recorded successfully"
        }
      }
    }
  }
}
